import React      from 'react';
import LogoLoader from "../../Loader/LogoLoader";

function withSuspense(WrappedComponent, useLogoLoader) {
    return <React.Suspense fallback={useLogoLoader ? <LogoLoader /> : ""}>
            {WrappedComponent}
        </React.Suspense>;
}
export default withSuspense;
